"use client";

import { useGlobalConfig } from "@/lib/global/GlobalConfiguration";
import clsx from "clsx";
import { Subtitle } from "..";
import styles from "./product-card.module.css";

export const ProductSaleTag = ({
  discountPercent,
  displayPercentOrSale,
  className,
}: {
  discountPercent?: number;
  displayPercentOrSale?: "showPercent" | "showSale";
  className?: string;
}) => {
  const { story } = useGlobalConfig();

  // Determine if we should show the percentage tag
  const shouldShowPercent =
    displayPercentOrSale === "showPercent" && !!discountPercent;
  // Determine if we should show the sale tag
  const shouldShowSale = displayPercentOrSale === "showSale";

  // Don't render anything if conditions aren't met
  if (!shouldShowPercent && !shouldShowSale) {
    return null;
  }

  const isPercentageTag = shouldShowPercent;

  return (
    <div>
      <div
        className={clsx(
          styles.card__tag,
          isPercentageTag ? styles.discount__percent__tag : styles.sale__tag,
          className,
        )}
        style={
          isPercentageTag
            ? undefined
            : ({
                "--tag-bg": story.saleColor?.color,
                "--tag-color": story.saleTextColor?.color,
              } as React.CSSProperties)
        }
      >
        <Subtitle noBrackets>
          {isPercentageTag ? `${Math.round(discountPercent!)}%` : "SALE"}
        </Subtitle>
      </div>
    </div>
  );
};
